export const Brand = {
  FM: 'FM',
  GP: 'GP',
  DAY1: 'DAY1',
};
